export default __webpack_public_path__ + "static/media/ic_eye.d7a3c854.svg";